/* eslint-disable */

import request from '@/utils/request'

export function getDepartmentApi(query) {
  return request({
    url: '/config-service/v1/department/list',
    method: 'get',
    params: query
  })
}

export function addDepartmentApi(query) {
  return request({
    url: '/config-service/v1/department/add',
    method: 'post',
    data: query
  })
}

export function updateDepartmentApi(query) {
  return request({
    url: `/config-service/v1/department/update`,
    method: 'put',
    data: query
  })
}
export function deleteDepartmentApi(query) {
  return request({
    url: '/config-service/v1/department/delete',
    method: 'delete',
    data: query
  })
}
